import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { RegistrarTransport } from "src/app/transports/registrar";

const useRegistrarAccountOptions = () => {
    const [registrarAccountOptions, setRegistrarAccountOptions] = useState<
        Array<SimpleFormSelectOption>
    >([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        setLoading(true);
        RegistrarTransport.list({ isActive: 1 })
            .then((res) => {
                setRegistrarAccountOptions(
                    res.map(({ registrar, login, id }) => ({
                        label: `${registrar} (${login})`,
                        value: id,
                    }))
                );
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return { registrarAccountOptions, error, loading };
};

export default useRegistrarAccountOptions;
